/**
 * Authors: mariushirjanu
 * Created: 11/01/2021
 */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICodeValue } from '../../../../type_definitions/datatypes';
import { BillingType } from '../../../main/order/entry/order-entry-data.service';

export const BILLINGTYPE_CENTRAL:BillingType = 'CENTRAL';
export const BILLINGTYPE_LOCAL:BillingType = 'LOCAL';

export const PAYMENTTYPE_PO:string = 'PO';
export const PAYMENTTYPE_CC:string = 'CC';
export const PAYMENTTYPE_PP:string = 'PP';

export const PROCUREMENTTYPE_BUY:string = 'BUY';
export const PROCUREMENTTYPE_LEASE:string = 'LEASE';

@Injectable()
export class BillingDataService {
  constructor(
    private translateService:TranslateService
  ) {
    /***/
  }

  public getBillingTypes():ICodeValue[] {
    return [
      {
        id: BILLINGTYPE_LOCAL,
        value: this.translateService.instant('APP.PAYMENT.LOCAL').toUpperCase(),
        sequence: 10
      },
      {
        id: BILLINGTYPE_CENTRAL,
        value: this.translateService.instant('APP.PAYMENT.CENTRAL').toUpperCase(),
        sequence: 20
      }
    ];
  }

  public getPaymentTypes():ICodeValue[] {
    return [
      {
        id: PAYMENTTYPE_PO,
        value: this.translateService.instant('APP.PAYMENT.BANK_TRANSFER'),
        sequence: 10
      },
      {
        id: PAYMENTTYPE_CC,
        value: this.translateService.instant('APP.PAYMENT.CREDIT_CARD'),
        sequence: 20
      }
    ];
  }

  public getProcurementTypes():ICodeValue[] {
    return [
      {
        id: PROCUREMENTTYPE_BUY,
        value: this.translateService.instant('APP.PAYMENT.BUY'),
        sequence: 10
      },
      {
        id: PROCUREMENTTYPE_LEASE,
        value: this.translateService.instant('APP.PAYMENT.LEASE'),
        sequence: 20
      }
    ];
  }
}